module.exports = __webpack_public_path__ + "static/media/the-matrix.d7a05a8b.png";